<template>
    <div class="zone">
            <header v-if="titolo"  class="msp-ui-panel-header">
                <h3 v-text="titolo"></h3>
            </header>
            <table v-if="!isNuoto(sport_id)" class="msp-ui-table msp-ui-table--compact msp-ui-table--horizontal-lines table-zone table-zone-z">
                <thead>
                    <tr>
                        <th class="table-zone-label">Zone di allenamento</th>
                        <th>Min</th>
                        <th>Max</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="zona in filteredZone" :key="zona.id"  :style="setStyle(coloreZona(zona.id))">
                        <td class="table-zone-label"><strong>{{codiceZona(zona.id)}}</strong> <span class="zone-nome">{{nomeZona(zona.id)}}</span></td>
                        <td><edit-zona @update="onUpdateZona" :mode="modeZona" :zona="zona" key_valore="da" :um_id="um_id" /></td>
                        <td><edit-zona @update="onUpdateZona"  :mode="modeZona" :zona="zona" key_valore="a" :um_id="um_id" /></td>
                        <td>{{um_descrizione}}</td>
                    </tr>
                </tbody>
            </table>

            <table v-if="isNuoto(sport_id)" class="msp-ui-table  msp-ui-table--compact msp-ui-table--horizontal-lines table-nospan table-zone">
                <thead>
                    <tr>
                        <th>Zona</th>
                        <th v-for="distanza in distanze"
                            :key = "distanza.id"
                            >{{distanza.nome}}</th>

                    </tr>
                </thead>
                <tbody>
                    <tr v-for="zona in filteredZone" :key="zona.id+'-'+zona.distanza"  :style="setStyle(coloreZonaAggregata(zona))">
                        <td class="table-zone-label">{{zona.nome}}</td>
                        <td v-for="distanza in distanze" :key = "distanza.id">
                            <edit-zona @update="onUpdateZona" :mode="mode" :zona="zonaByDistanza(zona,distanza.id)" key_valore="media" :um_id="um_id" ></edit-zona>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="msp-ui-alert" v-if="!hasZones">
                <div class="alert-nozone" >
                    <p>zone</p>
                </div>
            </div>
        </div>

</template>

<script>
import EditZona from './EditZona.vue';
import _constants from '@src/js/msp/constants.js';
import distanze from "@cached/distanze.json";
import _zone from "@cached/zone.json";
import _ums from "@cached/um.json";
import _umTipi from "@cached/um_tipo.json";
import { zonaIsDisplayable, zonaDefIsDisplayable } from '@src/js/msp/zone_utils.js';

const component = {
    components: {
        EditZona,
    },
    mixins: [
    ],
    props: ['titolo', 'mode', 'value', 'sport_id', 'um_id'],
    emits: ['input', 'reset'],
    data: function () {
        return {
            isEditing: false,
            distanze: distanze,
            ZONE:_zone,
            zone: [],
        };
    },
    created: function () {
    },
    computed: {
        um: function () {
            return _ums.find(el=>el.id === this.um_id);
        },
        um_descrizione: function () {
            return this.um?.suffix || "";
        },
        modeZona: function () {
            return this.isEditing ? "edit" : "view";
        },

        hasZones: function() {
            if (this.sport_id == _constants.ID_NUOTO) {
                return !!(this.zone && Object.getOwnPropertyNames(this.zone).length);
            } else {
                return this.zone && this.zone.length;
            }
        },

        zonaIds: function () {
            return this.ZONE
                .filter((el)=>(+el.sport_id == +this.sport_id))
                .map((el)=>+el.id)
                .sort((a,b)=>(+a>+b?1:-1));
        },

        z0: function () {
            if (!this.zone || !this.zone.length) return null;
            return this.zone.find(z => +z.id === 0) || null;
        },

        filteredZone: function () {
            if (!(this.zone && this.zone.length)) {
                return [];
            }
            if (this.isNuoto(this.sport_id)) {
                // Per nuoto filtra le definizioni statiche (senza da/a)
                return this.ZONE.filter(z =>
                    zonaDefIsDisplayable(z, this.sport_id) &&
                    this.zonaIds.indexOf(+z.id) !== -1
                );
            }
            return this.zone.filter(z =>
                zonaIsDisplayable(z, 'grafico') && this.zonaIds.indexOf(+z.id) !== -1
            );
        }

    },


    mounted: function () {
        this.initZone();
    },
    watch: {
        value: {
            deep: true,
            handler: function () {
                this.initZone();
            },
        },
    },
    methods: {
        startEditing: function () {
            this.isEditing = true;
        },

        initZone: function () {
            this.zone = this.value;
        },

        stopEditing: function () {
            this.isEditing = false;
        },

        abort: function () {
            this.initZone();
        },

        save: function () {
            const checkZone = this.checkZone(this.zone);
            if (checkZone.isValid) {
                this.$emit('input', this.zone);
                return true;
            } else {
                const errors = checkZone.errors.map(this.makeError);
                this.showAlert(errors);
                return false;
            }
        },

        showAlert: function (errors) {
            const stringErrors = errors.join('\n');
            alert(`Valori non validi:\n\n${stringErrors}`);
        },

        makeError: function ({zonaId}) {
            const zona = _zone.find(el=>el.id === zonaId);
            return `${zona.codice}`;
        },

        checkZone: function (zone) {
            const errors = zone.reduce((acc,zona)=>{
                if (+zona.id === 0) return acc; // Z0 sentinella: non validare
                const isValid = this.zonaIsValid(zona);
                if (!isValid) {
                    acc.push({ zonaId: zona.id });
                }
                return acc;
            }, []);
            return {
                isValid: !errors.length,
                errors: errors,
            }
        },

        reset: function () {
            this.$emit('reset');
            this.initZone();
        },

        zonaIsValid: function (zona) {
            if (!zona.a || !zona.da) {
                return true;
            }
            const umTipo = _umTipi.find(el=>el.id === this.um?.um_tipo_id);
            if (umTipo.more_is_better) {
                return zona.a > zona.da;
            } else {
                return zona.a < zona.da;
            }
        },

        onUpdateZona: function ({value, zona, key_valore}) {
            const newZone = [...this.zone];
            let zi = this.zone.findIndex(el=>el.id === zona.id);
            const incLinked = (key_valore === 'da') ? -1 : 1;
            const linkedIndex = zi + incLinked;
            const linkedKey = (incLinked === -1) ? "a" : "da";

            newZone[zi] = {
                ...newZone[zi],
                [key_valore]: value,
            };
            if ( (newZone[linkedIndex]) &&
                (newZone[linkedIndex][linkedKey]) &&
                (+newZone[linkedIndex].id !== 0) ) { // non aggiornare Z0 (sentinella limite minimo)
                if (newZone[linkedIndex].id === _constants.ZONE.REC) {
                    value = 0;
                }
                newZone[linkedIndex] = {
                    ...newZone[linkedIndex],
                    [linkedKey]: value,
                };
            }
            this.zone = [...newZone];
        },

        zonaByDistanza: function (zona, distanzaId) {
            let filtered = this.zone.find((el)=>(+el.id == +zona.id && el.distanza.toString() == distanzaId.toString()));
            return filtered;
        },


        coloreZona: function (id) {
            let zona = _zone.find(el=>el.id===id);
            return zona && zona.colore;
        },
        coloreZonaAggregata: function (zona) {
            if (!zona.codice_aggregazione) return null;
            const base = _zone.find(el => el.codice === zona.codice_aggregazione && el.sport_id === 1);
            return base && base.colore;
        },
        nomeZona: function (id) {
            let zona = _zone.find(el=>el.id===id);

            if (!zona) return "";

            return zona.descrizione || zona.nome;
        },
        codiceZona: function (id) {
            let zona = _zone.find(el=>el.id===id);

            return zona && zona.codice;
        },
        setStyle(col) {
            var style = `--color: ${col}`;

            return style;
        },

        isNuoto(sport_id) {
            return parseInt(sport_id, 10) === _constants.ID_NUOTO;
        },

    }
}
export default component;
</script>

<style lang="scss">
.zone {
    --color: transparent;
    container-type: inline-size;
    overflow-x: auto;
    tr th {
        height: var(--th-height, auto);
    }
    tr td {
        height: var(--cell-height, auto);
    }

    .table-zone-label {
        padding-left: var(--spacing-4);
        position: relative;
        &:before {
            position: absolute;
            top: 0;
            left: 0;
            width: var(--spacing-2);
            height: 100%;
            content: "";
            background: var(--color);

        }
    }

    @container (max-width: 320px) {
        .zone-nome {
            display: none;
        }
    }
}
</style>
